jQuery(document).ready(function ($) {
	var windowWidth = $(window).width();

	// Init header offset function
	headerOffset();

	// Update offset on scroll
	$(window).on('scroll resize', function () {
		headerOffset();
	});

	// Update offset on alert bar close
	$('.alert-bar .close--alert').on('click', function () {
		$('.alert-bar').remove();
		headerOffset();
	});

	// Change header to white on hover
	// if (windowWidth > 992) {
	// 	$('.header').on('mouseenter', function (e) {
	// 		if (!$('.header').hasClass('header--solid')) {
	// 			// $('.header__bg').fadeIn(300);
	// 			$('.header').addClass('header--white');
	// 		}
	// 	});

	// 	$('.header').on('mouseleave', function (e) {
	// 		if (!$('.header').hasClass('header--solid')) {
	// 			// $('.header__bg').fadeOut(300);
	// 			$('.header').removeClass('header--white');
	// 		}
	// 	});
	// }

	$('.icon--language').on('click', function (e) {
		e.preventDefault();
		$('#LanguageList').slideToggle('fast');
	});

	$('.btn--language').on('click', function e() {
		e.preventDefault();
		$('#LanguageListMobile').slideToggle('fast');
	});

	$('#LanguageList a').on('click', function (e) {
		e.preventDefault();
		$(this)
			.closest('form')
			.find('input[name="language_code"]')
			.val(e.currentTarget.dataset.value);
		// console.log(e.currentTarget.dataset.value);
		$('#localization_form').submit();
	});

	$('#LanguageListMobile a').on('click', function (e) {
		e.preventDefault();
		$(this)
			.closest('form')
			.find('input[name="language_code"]')
			.val(e.currentTarget.dataset.value);
		// console.log(e.currentTarget.dataset.value);
		$('#localization_form-mobile').submit();
	});

	// // Detect mouseenter on the parent li
	// $('li.top-level').on('mouseenter', function () {
	// 	$(this).find('ul.sub-menu').stop(true, true).slideDown(200); // Show submenu
	// });

	// // Detect mouseleave on the parent li
	// $('li.top-level').on('mouseleave', function () {
	// 	var submenu = $(this).find('ul.sub-menu');

	// 	// Use a timeout to delay hiding the submenu, allowing the user to move to the submenu
	// 	setTimeout(function () {
	// 		if (!submenu.is(':hover')) {
	// 			submenu.stop(true, true).slideUp(200); // Hide submenu
	// 		}
	// 	}, 200); // Delay hiding by 300ms to allow mouse transition
	// });

	// // Also detect mouseleave on the submenu itself
	// $('ul.sub-menu').on('mouseleave', function () {
	// 	$(this).stop(true, true).slideUp(200); // Hide submenu
	// });

	// Mega menu — hover intent prevents accidental switch on diagonal mouse movement
	var $navItems = $('.header__nav li.has-children');
	var switchDelay = 150;
	var closeDelay = 200;
	var switchTimer = null;
	var closeTimer = null;
	var $currentItem = null;

	$navItems.on('mouseenter', function () {
		var $this = $(this);
		clearTimeout(closeTimer);
		clearTimeout(switchTimer);

		if (!$currentItem) {
			$this.find('> .sub-menu').show();
			$currentItem = $this;
		} else if ($currentItem[0] !== $this[0]) {
			switchTimer = setTimeout(function () {
				$currentItem.find('> .sub-menu').hide();
				$this.find('> .sub-menu').show();
				$currentItem = $this;
			}, switchDelay);
		}
	});

	$navItems.on('mouseleave', function () {
		clearTimeout(switchTimer);
		var $this = $(this);
		closeTimer = setTimeout(function () {
			$this.find('> .sub-menu').hide();
			if ($currentItem && $currentItem[0] === $this[0]) {
				$currentItem = null;
			}
		}, closeDelay);
	});

	$('.header__nav .sub-menu')
		.on('mouseenter', function () {
			clearTimeout(closeTimer);
		})
		.on('mouseleave', function () {
			var $sub = $(this);
			closeTimer = setTimeout(function () {
				$sub.hide();
				$currentItem = null;
			}, closeDelay);
		});

	// Offset content from fixed header
	function headerOffset() {
		var headerHeight = $('.fixed-wrap').innerHeight();

		$('#main').css('padding-top', headerHeight + 'px');

		// $('.pdp__images').css('top', headerHeight + 'px');
		$('.mini-cart').css('height', 'calc( 100vh - ' + headerHeight + 'px )');

		$(window).on('scroll resize', function () {
			var newsHeight = $('.fixed-wrap .alert-bar').innerHeight();

			if ($(window).scrollTop() >= 250) {
				$('.fixed-wrap').addClass('scrolling');
				if (!$('.header').hasClass('header--solid')) {
					$('.header').addClass('header--white');
				}

				if (newsHeight != undefined) {
					$('.fixed-wrap').css(
						'transform',
						'translateY(-' + newsHeight + 'px)'
					);
				}

				// $('.mobile-menu__inner').css(
				// 	'height',
				// 	'calc( 100vh - ' + headerHeight + 'px )'
				// );
			} else {
				$('.fixed-wrap').removeClass('scrolling');
				$('.fixed-wrap').css('transform', 'translateY(0)');
				if (!$('.header').hasClass('header--solid')) {
					$('.header').removeClass('header--white');
				}
			}
		});
	}
});
